import { number } from 'prop-types';
import { getRelativeDate } from 'oxygen-lib-ui/helpers/date';

/**
 * converts timestamp to a formatted date string
 *
 * @export
 * @param {Number} timestamp unix epoch date in seconds as int
 * @returns {String} formatted date
 */

function FormattedDate({ timestamp }) {
  return getRelativeDate(timestamp);
}

FormattedDate.propTypes = {
  timestamp: number.isRequired
};

export default FormattedDate;
